<script setup lang="ts">
import { useRoute } from "vue-router";
import { computed } from "vue";

const route = useRoute();
const category = computed( () => {
  return route.meta.category;
} );
</script>

<template>
  <component :is="category" />
</template>
